import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserPortfolioNew } from "./utilities/ApiCalls";
import { processPortfolioNewToPages } from "./utilities/PortfolioNewProcessor";
import FlipBooks from "./FlipBooks";

// Extract token from URL immediately (before any React render)
function extractTokenFromURL() {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("token");
  } catch (e) {
    return null;
  }
}

const FALLBACK_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2YTczMzIxOWEyNzQwZWZmNWEyYWE2NzciLCJkZXZpY2VJZCI6IiIsImxvZ2luVHlwZSI6MywiaWF0IjoxNzg2NTI0OTIxLCJleHAiOjE4MDIwNzY5MjF9.POQDaegPx_tsVHWwkKTejlKOBcdSDvr3jNGADP3BUt4";

export default function PublicPortfolio() {
  const { userId } = useParams();
  const location = useLocation();
  const [port, setport] = useState([]);
  const [portMeta, setPortMeta] = useState({ bookName: "eBook", authorName: "" });
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const theme = useSelector((state) => state.theme?.mode) || "light";
  const appBgColor = theme === "dark" ? "#2A2A2A" : "#f0eee7";

  useEffect(() => {
    // Try token from URL query first, then location.search, then fallback
    const urlToken = extractTokenFromURL();
    const searchParams = new URLSearchParams(location.search);
    const queryToken = searchParams.get("token") || urlToken;
    
    const token = queryToken || FALLBACK_TOKEN;
    localStorage.setItem("loginDetails", token);
    console.log("[PublicPortfolio] token set, length:", token.length, "userId:", userId);

    async function portfolioFetch() {
      try {
        const response = await getUserPortfolioNew(userId);
        console.log("[PublicPortfolio] API status:", response?.status, "has data:", !!response?.data);
        if (response && response.status === "Success" && response.data) {
          const portfolioData = response.data;
          const pages = await processPortfolioNewToPages(portfolioData);
          console.log("[PublicPortfolio] Processed pages:", pages.length);
          setPortMeta({
            bookName: portfolioData.BookName || "eBook",
            authorName: portfolioData.AuthorName || "",
          });
          setport(pages);
        } else {
          const msg = response?.message || "No portfolio data returned";
          console.warn("[PublicPortfolio] Bad response:", msg, response);
          setErrorMsg(msg);
        }
      } catch (error) {
        console.error("[PublicPortfolio] Fetch error:", error?.message || error);
        setErrorMsg(error?.message || "Network error");
      } finally {
        setLoading(false);
      }
    }
    
    if (userId) {
      portfolioFetch();
    } else {
      setLoading(false);
      setErrorMsg("No user ID provided");
    }
  }, [userId, location.search]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: appBgColor }}>Loading...</div>;
  }

  if (port.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: appBgColor, fontSize: '18px', fontWeight: 'bold', gap: '12px' }}>
        <div>No eBook Found</div>
        {errorMsg ? <div style={{ fontSize: '14px', color: '#888', fontWeight: 'normal' }}>{errorMsg}</div> : null}
      </div>
    );
  }

  return (
    <div 
      style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center',
        width: '100%',
        textAlign: 'center',
        minHeight: '100dvh', 
        backgroundColor: appBgColor,
        padding: '0',
        boxSizing: 'border-box',
        overflow: 'auto'
      }}
    >
      <div style={{ margin: 'auto' }}>
        <FlipBooks data={port} meta={portMeta} />
      </div>
    </div>
  );
}
